import React from "react";

import Tooltip from "@material-ui/core/Tooltip";
import WarningIcon from "@material-ui/icons/Warning";

import CustomAutoCompleteFilter from "../../lib/components/customdatagridfilter/CustomFilter";
import { DateFormatter, FormatterNumber, FormatterNumber2Decimals, TextFormatter } from "../../lib/components/Formatters";
import { SummaryNumber, SummaryNumber2Decimal } from "../../lib/components/SummaryFormatter";
import { EnquiryLink, Selector } from "../../lib/components/EnquiryLink";
import { handleColumnsArrangement, handleColumnsWidth } from "../../lib/helpers/grid";

const cellWidthTiny = 50;
const cellWidthSmall = 80;
const cellWidthMedium = 150;
const cellWidthLarge = 200;

const defaultColumnProperties = {
  resizable: true,
  sortable: true,
  filterable: true,
};

let currentSpace = true;

export const ErrorCellFormatter = (row, column) => {
  const isError = row.edicomparisonerror || "";

  if (isError != "") {
    return (
      <Tooltip title={isError}>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <WarningIcon style={{ color: isError.includes("Missing") ? "white" : "red" }} />
        </div>
      </Tooltip>
    );
  }

  return <div></div>;
};

export const CustomEnquiryRenderer = (props: { column: any; row: any; selector: Selector; style?: any }) => {
  const { row, column } = props;
  const isError = (row.edicomparisonerror || "").split(", ");

  if (isError != "") {
    if (isError.includes("Missing")) {
      return <EnquiryLink {...props} selector={props.selector} style={{ color: "white", fontWeight: "normal" }} />;
    } else if (isError.find((col) => col == column.key)) {
      return <EnquiryLink {...props} selector={props.selector} style={{ color: "red", fontWeight: "bold" }} />;
    }
  }

  return <EnquiryLink {...props} selector={props.selector} />;
};

export const ColumnsEDIFileComparisonCurrent = (data, filters, arrangement, columnsWidth) => {
  let postValueInfo = "";

  if (data) {
    if (currentSpace) {
      postValueInfo = " ";
    }
    currentSpace = !currentSpace;
  }

  const columns = [
    {
      key: "edicomparisonerror",
      name: "#E" + postValueInfo,
      width: cellWidthTiny,
      formatter: ({ row, column }) => ErrorCellFormatter(row, column),
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"edicomparisonerror"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Location Code",
      name: "Location Code" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Location Code"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Ref No",
      name: "Load Ref" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Ref No"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Producer ID",
      name: "Producer ID" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Producer ID"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Farm Number",
      name: "Farm Number" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Farm Number"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Orig Intake Waybill",
      name: "Orig Intake Waybill" + postValueInfo,
      width: cellWidthSmall,
      formatter: (props) => <CustomEnquiryRenderer {...props} selector={Selector.IntakeWaybill} />,
      filterRenderer: (e) => {
        return (
          <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Orig Intake Waybill"} data={data} section={"edifilecomparisoncurrent"} />
        );
      },
    },
    {
      key: "Intake Waybill",
      name: "Intake Waybill" + postValueInfo,
      width: cellWidthSmall,
      formatter: (props) => <CustomEnquiryRenderer {...props} selector={Selector.IntakeWaybill} />,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Intake Waybill"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Barcode",
      name: "Barcode" + postValueInfo,
      width: cellWidthSmall,
      formatter: (props) => <CustomEnquiryRenderer {...props} selector={Selector.Barcode} />,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Barcode"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "No Cartons",
      name: "No Cartons" + postValueInfo,
      width: cellWidthSmall,
      formatter: FormatterNumber,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"No Cartons"} data={data} section={"edifilecomparisoncurrent"} />;
      },
      summaryFormatter: SummaryNumber,
    },
    {
      key: "Pallet Size",
      name: "Pallet Size" + postValueInfo,
      width: cellWidthSmall,
      formatter: FormatterNumber2Decimals,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Pallet Size"} data={data} section={"edifilecomparisoncurrent"} />;
      },
      summaryFormatter: SummaryNumber2Decimal,
    },
    {
      key: "Commodity Code",
      name: "Commodity Code" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Commodity Code"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Variety Code",
      name: "Variety Code" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Variety Code"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Grade Code",
      name: "Grade Code" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Grade Code"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Count Code",
      name: "Count Code" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Count Code"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Pack Code",
      name: "Pack Code" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Pack Code"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Mark Code",
      name: "Mark Code" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Mark Code"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Inventory Code",
      name: "Inventory Code" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Inventory Code"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Date Entered",
      name: "Date Entered" + postValueInfo,
      width: cellWidthSmall,
      formatter: DateFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Date Entered"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Pallet ID",
      name: "Pallet ID" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Pallet ID"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Intake ID",
      name: "Intake ID" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Intake ID"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Dispatch ID",
      name: "Dispatch ID" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Dispatch ID"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Depot",
      name: "Depot" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Depot"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Time Entered",
      name: "Time Entered" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Time Entered"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Date Dispatched",
      name: "Date Dispatched" + postValueInfo,
      width: cellWidthSmall,
      formatter: DateFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Date Dispatched"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Time Dispatched",
      name: "Time Dispatched" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Time Dispatched"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Processing",
      name: "Processing" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Processing"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Selected",
      name: "Selected" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Selected"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Price",
      name: "Price" + postValueInfo,
      width: cellWidthSmall,
      formatter: FormatterNumber2Decimals,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Price"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Allocated",
      name: "Allocated" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Allocated"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Allocation",
      name: "Allocation" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Allocation"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Temperature",
      name: "Temperature" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Temperature"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Channel",
      name: "Channel" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Channel"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Picking Ref",
      name: "Picking Ref" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Picking Ref"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Target Market",
      name: "Target Market" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Target Market"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Intake Pallet ID",
      name: "Intake Pallet ID" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Intake Pallet ID"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Pallet Base Type",
      name: "Pallet Base Type" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Pallet Base Type"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Fail Safe ID",
      name: "Fail Safe ID" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Fail Safe ID"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Organization",
      name: "Organization" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Organization"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Sequence Number",
      name: "Sequence Number" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Sequence Number"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Bay",
      name: "Bay" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Bay"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Cold Date",
      name: "Cold Date" + postValueInfo,
      width: cellWidthSmall,
      formatter: DateFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Cold Date"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Last Invoice",
      name: "Last Invoice" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Last Invoice"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Cooler ID",
      name: "Cooler ID" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Cooler ID"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Last Invoice Date",
      name: "Last Invoice Date" + postValueInfo,
      width: cellWidthSmall,
      formatter: DateFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Last Invoice Date"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Invoicing",
      name: "Invoicing" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Invoicing"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Intake Type",
      name: "Intake Type" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Intake Type"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Exported",
      name: "Exported" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Exported"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "PalTrak",
      name: "PalTrak" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"PalTrak"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Rebuilt",
      name: "Rebuilt" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Rebuilt"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Last Edit Date",
      name: "Last Edit Date" + postValueInfo,
      width: cellWidthSmall,
      formatter: DateFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Last Edit Date"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Pallet Movement",
      name: "Pallet Movement" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Pallet Movement"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Allocated Stock",
      name: "Allocated Stock" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Allocated Stock"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Rejected",
      name: "Rejected" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Rejected"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Transfer",
      name: "Transfer" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Transfer"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Mini Pallet",
      name: "Mini Pallet" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Mini Pallet"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "SV",
      name: "SV" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"SV"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Product Group",
      name: "Product Group" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Product Group"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Product Char",
      name: "Product Char" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Product Char"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Reject Reason",
      name: "Reject Reason" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Reject Reason"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Mixed Ind",
      name: "Mixed Ind" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Mixed Ind"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Weight",
      name: "Weight" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Weight"} data={data} section={"edifilecomparisoncurrent"} />;
      },
      summaryFormatter: SummaryNumber2Decimal,
    },
    {
      key: "Stock Pool",
      name: "Stock Pool" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Stock Pool"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Country",
      name: "Country" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Country"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "SSCC",
      name: "SSCC" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"SSCC"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Orig Intake Date",
      name: "Orig Intake Date" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Orig Intake Date"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "PHC",
      name: "PHC" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"PHC"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Sell By",
      name: "Sell By" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Sell By"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Stock Value",
      name: "Stock Value" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Stock Value"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Old Barcode",
      name: "Old Barcode" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Old Barcode"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Trader ID",
      name: "Trader ID" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Trader ID"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Consignee ID",
      name: "Consignee ID" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Consignee ID"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Inspector Name",
      name: "Inspector Name" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Inspector Name"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Inspection Point",
      name: "Inspection Point" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Inspection Point"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Inspection Date",
      name: "Inspection Date" + postValueInfo,
      width: cellWidthSmall,
      formatter: DateFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Inspection Date"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Inspection Time",
      name: "Inspection Time" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Inspection Time"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Inspection Report",
      name: "Inspection Report" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Inspection Report"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "UserName",
      name: "UserName" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"UserName"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "dispatch customer id",
      name: "dispatch customer id" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return (
          <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"dispatch customer id"} data={data} section={"edifilecomparisoncurrent"} />
        );
      },
    },
    {
      key: "Temp Tail",
      name: "Temp Tail" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Temp Tail"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Batch",
      name: "Batch" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Batch"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Orchard",
      name: "Orchard" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Orchard"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Internal Barcode",
      name: "Internal Barcode" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Internal Barcode"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "QC Flag",
      name: "QC Flag" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"QC Flag"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "QC User",
      name: "QC User" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"QC User"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "QC Blocked",
      name: "QC Blocked" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"QC Blocked"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Order ID",
      name: "Order ID" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Order ID"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Hatch",
      name: "Hatch" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Hatch"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Deck",
      name: "Deck" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Deck"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Orig Location Code",
      name: "Orig Location Code" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Orig Location Code"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Tax",
      name: "Tax" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Tax"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Production ID",
      name: "Production ID" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Production ID"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "From Location Code",
      name: "From Location Code" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"From Location Code"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Verify",
      name: "Verify" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Verify"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "To Location Code",
      name: "To Location Code" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"To Location Code"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "FruitTrak Internal Pack Code",
      name: "FruitTrak Internal Pack Code" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return (
          <CustomAutoCompleteFilter
            {...e}
            multiSelection={true}
            currentFilters={filters}
            fieldname={"FruitTrak Internal Pack Code"}
            data={data}
            section={"edifilecomparisoncurrent"}
          />
        );
      },
    },
    {
      key: "Order No",
      name: "Order No" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Order No"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Purchase Price",
      name: "Purchase Price" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Purchase Price"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Seal Number",
      name: "Seal Number" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Seal Number"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Advance Price",
      name: "Advance Price" + postValueInfo,
      width: cellWidthSmall,
      formatter: FormatterNumber2Decimals,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Advance Price"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Load Date",
      name: "Load Date" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Load Date"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Start Loading Time",
      name: "Start Loading Time" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Start Loading Time"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Local FOB",
      name: "Local FOB" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Local FOB"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Pre Allocated",
      name: "Pre Allocated" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Pre Allocated"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Insurance Value",
      name: "Insurance Value" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Insurance Value"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Depot Stock  ID",
      name: "Depot Stock  ID" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Depot Stock  ID"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Inner Pack",
      name: "Inner Pack" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Inner Pack"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Temp Type",
      name: "Temp Type" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Temp Type"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Inner Cartons",
      name: "Inner Cartons" + postValueInfo,
      width: cellWidthSmall,
      formatter: FormatterNumber,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Inner Cartons"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Pallet Status",
      name: "Pallet Status" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Pallet Status"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Contract ID",
      name: "Contract ID" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Contract ID"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Receiver",
      name: "Receiver" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Receiver"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Target Price",
      name: "Target Price" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Target Price"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Must GO",
      name: "Must GO" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Must GO"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Advance Purchase",
      name: "Advance Purchase" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Advance Purchase"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Principal",
      name: "Principal" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Principal"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Target Region",
      name: "Target Region" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Target Region"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Target Country",
      name: "Target Country" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Target Country"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "QC Selected",
      name: "QC Selected" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"QC Selected"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "QC UserName",
      name: "QC UserName" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"QC UserName"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Special Order",
      name: "Special Order" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Special Order"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Destination Type CN",
      name: "Destination Type CN" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return (
          <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Destination Type CN"} data={data} section={"edifilecomparisoncurrent"} />
        );
      },
    },
    {
      key: "Best Before",
      name: "Best Before" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Best Before"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Display Until",
      name: "Display Until" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Display Until"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Expiry Code",
      name: "Expiry Code" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Expiry Code"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Orig PHC Location Code",
      name: "Orig PHC Location Code" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return (
          <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Orig PHC Location Code"} data={data} section={"edifilecomparisoncurrent"} />
        );
      },
    },
    {
      key: "PHC Location Code",
      name: "PHC Location Code" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"PHC Location Code"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Estimate Return",
      name: "Estimate Return" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Estimate Return"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Purchase Pallet ID",
      name: "Purchase Pallet ID" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Purchase Pallet ID"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "GTIN ID",
      name: "GTIN ID" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"GTIN ID"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Season",
      name: "Season" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Season"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Row",
      name: "Row" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Row"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Position",
      name: "Position" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Position"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Custom Field 1",
      name: "Custom Field 1" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Custom Field 1"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Transaction Date",
      name: "Transaction Date" + postValueInfo,
      width: cellWidthSmall,
      formatter: DateFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Transaction Date"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Orig Farm Number",
      name: "Orig Farm Number" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Orig Farm Number"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Complexity",
      name: "Complexity" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Complexity"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Intake Stock Value",
      name: "Intake Stock Value" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Intake Stock Value"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Gross Weight",
      name: "Gross Weight" + postValueInfo,
      width: cellWidthSmall,
      formatter: FormatterNumber2Decimals,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Gross Weight"} data={data} section={"edifilecomparisoncurrent"} />;
      },
      summaryFormatter: SummaryNumber2Decimal,
    },
    {
      key: "Orig Inspection Date",
      name: "Orig Inspection Date" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return (
          <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Orig Inspection Date"} data={data} section={"edifilecomparisoncurrent"} />
        );
      },
    },
    {
      key: "UPN",
      name: "UPN" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"UPN"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Actual Variety",
      name: "Actual Variety" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Actual Variety"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "PalletTreatment ID",
      name: "PalletTreatment ID" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"PalletTreatment ID"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Pooling Packaging Factor",
      name: "Pooling Packaging Factor" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return (
          <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Pooling Packaging Factor"} data={data} section={"edifilecomparisoncurrent"} />
        );
      },
    },
    {
      key: "Producer Deal Type",
      name: "Producer Deal Type" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Producer Deal Type"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Weighing Location",
      name: "Weighing Location" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Weighing Location"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Weighing Date Time",
      name: "Weighing Date Time" + postValueInfo,
      width: cellWidthSmall,
      formatter: DateFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Weighing Date Time"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Vitrax UID",
      name: "Vitrax UID" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Vitrax UID"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Fruittrak Intake ID",
      name: "Fruittrak Intake ID" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return (
          <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Fruittrak Intake ID"} data={data} section={"edifilecomparisoncurrent"} />
        );
      },
    },
    {
      key: "Phyto Verification",
      name: "Phyto Verification" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Phyto Verification"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Inner Carton Weight",
      name: "Inner Carton Weight" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return (
          <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Inner Carton Weight"} data={data} section={"edifilecomparisoncurrent"} />
        );
      },
    },
    {
      key: "VAT Code",
      name: "VAT Code" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"VAT Code"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "PQI Number",
      name: "PQI Number" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"PQI Number"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
    {
      key: "Pricing Sheet Applied Date",
      name: "Pricing Sheet Applied Date" + postValueInfo,
      width: cellWidthSmall,
      formatter: DateFormatter,
      filterRenderer: (e) => {
        return (
          <CustomAutoCompleteFilter
            {...e}
            multiSelection={true}
            currentFilters={filters}
            fieldname={"Pricing Sheet Applied Date"}
            data={data}
            section={"edifilecomparisoncurrent"}
          />
        );
      },
    },
    {
      key: "Pack Date",
      name: "Pack Date" + postValueInfo,
      width: cellWidthSmall,
      formatter: DateFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Pack Date"} data={data} section={"edifilecomparisoncurrent"} />;
      },
    },
  ].map((c) => ({ ...c, ...defaultColumnProperties }));

  let columnsArranged = [];
  columnsArranged = handleColumnsArrangement(columnsArranged, arrangement, columns);
  columnsArranged = handleColumnsWidth(columnsArranged, columnsWidth, columns);
  return columnsArranged;
};
